<template>
  <div>
    Prevoyance
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Prevoyance'
}
</script>
